    const carousels = document.querySelectorAll(".carousel_container-imgs,.nosto_slider,.yotpo-slider-container");
    const prevBtn = document.querySelectorAll(".carousel_btn-prev");
    const nextBtn = document.querySelectorAll(".carousel_btn-next");
    let carsouselImages = document.querySelector(".carousel_img").clientWidth;    
    
    //Next Carousel
    const nextCarousel = (carousel) => {
      if (carousel.scrollLeft + carousel.offsetWidth < carousel.scrollWidth) {
        console.log(carousel.scrollLeft + carousel.offsetWidth);
        carousel.scrollBy({
          left: carsouselImages,
          top: 0,
          behavior: "smooth"
        });
      } else {
        console.log("end");
        carousel.scrollTo({
          left: -carousel.scrollWidth,
          top: 0,
          behavior: "smooth"
        });
      }
    };
    
    //Prev Carousel
    const prevCarousel = (carousel) => {
      if (carousel.scrollLeft != 0) {
        console.log(carsouselImages);
        carousel.scrollBy({
          left: -carsouselImages,
          top: 0,
          behavior: "smooth"
        });
      } else {
        carousel.scrollTo({
          left: carousel.scrollWidth,
          top: 0,
          behavior: "smooth"
        });
      }
    };
    
    carousels.forEach((carousel, index) => {
      nextBtn[index].addEventListener("click", (e) => {
        nextCarousel(carousel);
      });
      prevBtn[index].addEventListener("click", (e) => {
        prevCarousel(carousel);
      });
    });
